import React, { Component } from 'react';
import { Button, ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../../content/css/ContractReviewer.css';
import { analysisActions as actions } from '../../../actions';
import { analysisConstants } from '../../../constants';
import { history } from '../../../helpers';
import { LoadingIcon } from '../../LoadingIcon';
import LoadingListener from '../../../helpers/loadingListener';
import ListCard from './ListCard';
import AuthService from '../../../services/auth.service';

const ownerFilterType = {
    SHOW_ALL: "SHOW_ALL",
    SHOW_MINE: "SHOW_MINE"
}

class PortfolioAnalysisList extends Component {

    constructor(props, context) {
        super(props, context);

        this.authService = new AuthService();
        this.loadingListener = new LoadingListener([analysisConstants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST]);

        this.state = {
            filteredReports: this.filterReports(Object.values(this.props.portfolioAnalyses), this.authService.isFreemium() ? null : this.authService.getUserId(), ownerFilterType.SHOW_MINE),
            ownerFilter: ownerFilterType.SHOW_MINE
        };
    }

    componentDidMount() {
        if (Object.keys(this.props.portfolioAnalyses).length == 0) {
            this.props.requestPortfolioAnalysesList();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.portfolioAnalyses != this.props.portfolioAnalyses) {
            let userId = this.authService.isFreemium() ? null : this.authService.getUserId();
            this.setState({ filteredReports: this.filterReports(Object.values(this.props.portfolioAnalyses), userId, this.state.ownerFilter) });
        }
        if (prevState.ownerFilter != this.state.ownerFilter) {
            let userId = this.authService.isFreemium() ? null : this.authService.getUserId();
            this.setState({ filteredReports: this.filterReports(Object.values(this.props.portfolioAnalyses), userId, this.state.ownerFilter) });
        }
    }

    handleCreateNewAnalysisClick = () => {
        history.push("/reports/create");
    }

    handleOwnerFilterChange = (eventKey, event) => {
        this.setState({ ownerFilter: eventKey });
    }

    filterReports = (reports, userId, ownerFilter) => {
        return reports.filter(x => this.isOwner(x, userId, ownerFilter));
    }

    isOwner = (report, userId, filter) => {
        if (this.authService.isFreemium()) return true;
        if (filter == ownerFilterType.SHOW_MINE) return report.userId == userId;
        else if (filter == ownerFilterType.SHOW_ALL) return true;
    }

    getDocumentCount = (report) => {
        if (report.documentAnalysisIds) return report.documentAnalysisIds.length;
        else if (report.documentAnalyses) return report.documentAnalyses.length;
    }

    getContractTypes = (report) => {
        if (report.contractTypes) return report.contractTypes;
        else if (report.documentAnalyses) return report.documentAnalyses.map(x => x.contractType);
    }

    getItems() {
        let self = this;
        return this.state.filteredReports.map((report, i) => (
            <ListCard
                id={report.id}
                name={report.name}
                date={report.wasSaved}
                description={report.description}
                documentCount={this.getDocumentCount(report)}
                contractTypes={this.getContractTypes(report)}
                onNameChange={self.props.editPortfolioAnalysisName}
                onDescriptionChange={self.props.editPortfolioAnalysisDescription}
            />
        ));
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let isAdmin = this.authService.isAdmin();

        return (
            <div className="portfolio-overview">
                {isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {!isLoading &&
                    <React.Fragment>
                        <h2>Your portfolio reports</h2>

                        <div className="toolbar">
                            {isAdmin &&
                                <div className="filter-owner">
                                    <DropdownButton title={`Filter: ${this.state.ownerFilter}`} id={`dropdown-basic`} onSelect={this.handleOwnerFilterChange}>
                                        <MenuItem key={ownerFilterType.SHOW_MINE} eventKey={ownerFilterType.SHOW_MINE}>{ownerFilterType.SHOW_MINE}</MenuItem>
                                        <MenuItem key={ownerFilterType.SHOW_ALL} eventKey={ownerFilterType.SHOW_ALL}>{ownerFilterType.SHOW_ALL}</MenuItem>
                                    </DropdownButton>
                                </div>
                            }
                            <ButtonGroup>
                                {isAdmin &&
                                    <Button className="btn btn-primary" onClick={this.handleCreateNewAnalysisClick}>New report</Button>
                                }
                                <Button className="btn btn-primary" onClick={this.props.requestPortfolioAnalysesList}>Refresh</Button>
                            </ButtonGroup>
                        </div>
                        <hr />

                        <div className="items">
                            {this.getItems()}
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => state.analysis,
    dispatch => bindActionCreators(actions, dispatch)
)(PortfolioAnalysisList);



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioList/PortfolioAnalysisList.js